import React, { Suspense, useEffect, useRef, useState } from "react";

import configModuleIcon from "../../assets/Icons/module_icons/configuration_module_icon.svg";
import engineeringmoduleIcon from "../../assets/Icons/module_icons/engineering_module_icon.svg";
import storesModuleIcon from "../../assets/Icons/module_icons/store_module_icon.svg";
import planningModuleIcon from "../../assets/Icons/module_icons/planning_module_icon.svg";
import maintenanceModuleIcon from "../../assets/Icons/module_icons/maintenance_module_icon.svg";
import shopMaintenanceIconModule from "../../assets/Icons/module_icons/shop_maintenance_module_icon.svg";
import reliabilityIconModule from "../../assets/Icons/module_icons/reliability_module_icon.svg";
import financeIconModule from "../../assets/Icons/module_icons/finance_module_icon.svg";
import customersIconModule from "../../assets/Icons/module_icons/customers_module_icon.svg";
import technicalRecordsIconModule from "../../assets/Icons/module_icons/technical_records_module_icon.svg";
import vendorIcon from "../../assets/Icons/module_icons/vendor_module_icon.svg";
import customDashboardIconModule from "../../assets/Icons/module_icons/custom_dashboard_icon.svg";
import homeIcon from "../../assets/Icons/module_icons/home_icon.svg";
import partEntryIcon from "../../assets/Icons/part_entries_icon.svg";
import batchesIcon from "../../assets/Icons/batches_icon.svg";
import unitsConvertsIcon from "../../assets/Icons/units_converts_icon.svg";
import consumibleExpandibleIcon from "../../assets/Icons/consumible_expandible_icon.svg";
import physicalInventoryIcon from "../../assets/Icons/physical_inventory_icon.svg";
import iconViewMore from "../../assets/Icons/view_more_icon.svg";
import fileIcon from "../../assets/Icons/file_icon.svg";
import transactionIcon from "../../assets/Icons/transaction_icon.svg";
import limitedAccessImg from "../../assets/Images/LimitedAccess.svg";
import supplyChainIcon from "../../assets/Icons/module_icons/supply_chain_icon.svg";
import { ProfileMenu } from "../Profile-menu/ProfileMenu";
import authService, {
  getAnchoredResourceByUser,
  saveAnchoredResource,
  updateHistoryNavigation,
} from "../../services/authService";
import { Notifications } from "../Notifications/Notifications";
import { useLocation, useNavigate } from "react-router-dom";
import { getActiveMenuModules } from "../../services/wrapperService";
import { environment } from "../../environments/environment";
import "./wrapper.scss";
import { saveModuleSelectedId } from "../../services/localStorageService";
import { CONTEXT_TYPES, HTTP_RESPONSE_CODES } from "../../globals/globals";
import { Link, Popover, Toolbar, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  addTab,
  addTabPinned,
  addTabWithoutActive,
  clearActiveTab,
  closeTab,
  pinOrUnPinTab,
  setActiveTab,
} from "../../redux/features/TabsManager/tabSlice";
import { AircraftConfiguration } from "../../modules/ConfigurationModule/components/AircraftConfiguration/AircraftConfiguration";
import { PartsConfiguration } from "../../modules/ConfigurationModule/components/PartsConfiguration/PartsConfiguration";
import { LocationsConfigurationComponent } from "../../modules/ConfigurationModule/components/LocationsConfiguration/LocationsConfigurationComponent";
import { use } from "react";
import aircraftImg from "../../assets/Images/previews/aircraft.png";
import { PartRequest } from "../../modules/StoresModule/Components/PartRequest/PartRequest";
import { PartRequestManagement } from "../../modules/SupplyChainModules/Components/PartRequest/PartRequest";

import { InventoryManagement } from "../../modules/StoresModule/Components/InventoryManagementComponent/InventoryManagement";
import { NewPartRequest } from "../../modules/StoresModule/Components/PartRequest/createNewPartRequest/NewPartRequest";
import { attachContextmenuInfo } from "../../services/contextMenuService";
import KeepAlive, { useAliveController } from "react-activation";
import { useSnackBar } from "../../hooks/useSnackBar";
import { ConfigurationModule } from "../../modules/ConfigurationModule/components/ConfigurationModule/ConfigurationModule";
import { StoreModule } from "../../modules/StoresModule/Components/StoreComponent/StoreModule";
import { PathNotFoundComponent } from "../PathNotFoundComponent/PathNotFoundComponent";
import { InventoryTransaction } from "../../modules/StoresModule/Components/InventoryTransaction/InventoryTransaction";
import { SupplyChainComponent } from "../../modules/SupplyChainModules/Components/SupplyChainComponent/SupplyChainComponent";
import { OrdersManagement } from "../../modules/StoresModule/Components/Orders/OrdersManagement";
import QuoteTrack from "../../modules/SupplyChainModules/Components/QuoteTrack/QuoteTrack";
import { PackageIntake } from "../../modules/StoresModule/Components/PackageIntake/PackageIntake";
import { ModulesMenu } from "../ModulesMenu/ModulesMenu";
import { GlobalSearchButton } from "../GlobalSearch/GlobalSearchButton";
import { ReceivingManagement } from "../../modules/StoresModule/Components/ReceivingManagement/ReceivingManagement";
import { VendorModule } from "../../modules/VendorModule/Components/VendorModule/VendorModule";
import VendorApproval from "../../modules/VendorModule/Components/VendorApproval/VendorApproval";
import VendorAwb from "../../modules/VendorModule/Components/VendorAWB/VendorAwb";
import { Discrepancy } from "../../modules/SupplyChainModules/Components/Discrepancy/Discrepancy";
import HomeDashboardModule from "../../modules/CustomDashboardModule/components/dashboard/HomeDashboardModule";
import StoreDashboardModule from "../../modules/CustomDashboardModule/components/dashboard/StoreDashboardModule";
import ConfigurationDashboardModule from "../../modules/CustomDashboardModule/components/dashboard/ConfigurationDashboardModule";
import SupplyChainDashboardModule from "../../modules/CustomDashboardModule/components/dashboard/SupplyChainDashboardModule";
import VendorDashboardModule from "../../modules/CustomDashboardModule/components/dashboard/VendorDashboardModule";
export const tabMap = {
  "/configuration/aircraft": {
    title: "Aircraft",
    componentKey: "AircraftConfiguration",
    keepAlive: true,
  },
  "/configuration/parts": {
    title: "Parts",
    componentKey: "PartsConfiguration",
    keepAlive: true,
  },
  "/configuration/locations-configuration": {
    title: "Locations",
    componentKey: "LocationsConfiguration",
    keepAlive: true,
  },
  "/store/inventory-management": {
    title: "Inventory Management",
    componentKey: "InventoryManagement",
    keepAlive: true,
  },
  "/store/part-request-management": {
    title: "Part Request Management",
    componentKey: "PartRequest",
    keepAlive: true,
  },
  "/supplychain/part-request-management": {
    title: "Part Request Management",
    componentKey: "PartRequestSupplyChain",
    keepAlive: true,
  },
  "/store/new-part-request": {
    title: "New Part Request",
    componentKey: "NewPartRequest",
    keepAlive: true,
  },
  "/customdashboard": {
    title: "Home",
    componentKey: "CustomDashboard",
    keepAlive: false,
  },
  "/supplychain": {
    title: "Supply Chain",
    componentKey: "Supply Chain",
    keepAlive: false,
  },
  "/store": {
    title: "Stores",
    componentKey: "Stores",
    keepAlive: false,
  },
  "/vendor": {
    title: "Vendor",
    componentKey: "Vendor",
    keepAlive: false,
  },
  "/vendor/vendor-approval": {
    title: "Vendor Approval",
    componentKey: "VendorApproval",
    keepAlive: true,
  },
  "/vendor/awb": {
    title: "Vendor AWB",
    componentKey: "VendorAwb",
    keepAlive: true,
  },
  "/vendor/quote-entry": {
    title: "Quote Entry",
    componentKey: "quoteEntry",
    keepAlive: true,
  },
  "/configuration": {
    title: "Configuration",
    componentKey: "Configuration",
    keepAlive: false,
  },
  "/store/inventory-transaction": {
    title: "Inventory Transaction",
    componentKey: "InventoryTransaction",
    keepAlive: true,
  },
  "/supplychain/orders-management": {
    title: "Orders Management",
    componentKey: "OrdersManagement",
    keepAlive: true,
  },
  "/supplychain/quote-tracking": {
    title: "Quote Tracking",
    componentKey: "QuoteTrack",
    keepAlive: true,
  },
  "/store/receiving": {
    title: "Receiving",
    componentKey: "ReceivingManagement",
    keepAlive: true,
  },
  "/supplychain/discrepancy": {
    title: "Discrepancy Management",
    componentKey: "Discrepancy",
    keepAlive: true,
  },
};
export const iconsMapSvg = {
  configModuleIcon: "icon-configuration_module_icon",
  engineeringmoduleIcon: "icon-engineering_module_icon",
  storesModuleIcon: "icon-store_module_icon",
  planningModuleIcon: "icon-planning_module_icon",
  maintenanceModuleIcon: "icon-maintenance_module_icon",
  shopMaintenanceIconModule: "icon-shop_maintenance_module_icon",
  reliabilityIconModule: "icon-reliability_module_icon",
  financeIconModule: "icon-finance_module_icon",
  customersIconModule: "icon-customers_module_icon",
  technicalRecordsIconModule: "icon-maintenance_module_icon",
  homeIconModule: "icon-home_icon",
  supplyChainIconModule: "icon-supply-chain",
  vendorIcon: "icon-business",
};
export const Wrapper = ({ children, currentModule = "" }) => {
  const navigate = useNavigate();

  const { getUsername } = authService();

  const iconsMap = {
    configModuleIcon: configModuleIcon,
    engineeringmoduleIcon: engineeringmoduleIcon,
    storesModuleIcon: storesModuleIcon,
    planningModuleIcon: planningModuleIcon,
    maintenanceModuleIcon: maintenanceModuleIcon,
    shopMaintenanceIconModule: shopMaintenanceIconModule,
    reliabilityIconModule: reliabilityIconModule,
    financeIconModule: financeIconModule,
    customersIconModule: customersIconModule,
    technicalRecordsIconModule: technicalRecordsIconModule,
    homeIconModule: homeIcon,
    supplyChainIconModule: supplyChainIcon,
    vendorIcon: vendorIcon,
  };

  const previewImages = {
    AircraftConfiguration: aircraftImg,
    PartsConfiguration: "../../assets/Images/previews/parts.png",
    LocationsConfiguration: "../../assets/Images/previews/locations.png",
  };
  const [modules_availables, setmodules_availables] = useState([]);
  const { successMsg, warningMsg, infoMsg } = useSnackBar();
  const files_results = [
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
    {
      icon_path: fileIcon,
      fileName: "lorem ipsum dolor sit",
    },
  ];

  const transactions_results = [
    {
      path_icon: transactionIcon,
      transactionName: "lorem ipsum dolor sit",
    },
    {
      path_icon: transactionIcon,
      transactionName: "lorem ipsum dolor sit",
    },
    {
      path_icon: transactionIcon,
      transactionName: "lorem ipsum dolor sit",
    },
    {
      path_icon: transactionIcon,
      transactionName: "lorem ipsum dolor sit",
    },
  ];
  const dispatch = useDispatch();
  const { openTabs, activeTab } = useSelector((state) => state.tabs);
  const company_name = "Kodo";
  const [achronym, setAchronym] = useState("U");
  const [isSearching, setIsSearching] = useState(false);
  const [sizeSidebar, setSizeSidebar] = useState("fullwidth");
  const [viewAllModules, setviewAllModules] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showNotificationsMenu, setShowNotificationsMenu] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companySelected, setCompanySelected] = useState(null);
  const [time, setTime] = useState(new Date());

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const getContextMenuOptions = (tab) => {
    const nameItem = tab.isModule ? "Module" : "Resource";
    return {
      "parts-configuration": {
        label: tab.isPinned
          ? `Unpin ${nameItem} from Taskbar`
          : `Pin  ${nameItem} to Taskbar`,
        icon: tab.isPinned ? "icon-pinned" : "icon-pinn",
        callback: (part) => {
          if (tab.id == -1 || tab.title == "Home") {
            infoMsg("Information", `This ${nameItem} Cannot be Pinned`, 2000);

            return;
          }
          if (tab.isPinned) {
            dispatch(pinOrUnPinTab({ path: tab.path, isPinned: false }));
          } else {
            dispatch(pinOrUnPinTab({ path: tab.path, isPinned: true }));
          }
          saveAnchoredResource(!tab.isPinned, tab.id, tab.isModule);
        },
      },
    };
  };
  const contextMenuInfo = {
    type: CONTEXT_TYPES.PART,
    highlightstyle: "",
  };

  const createAchronym = () => {
    try {
      const name = getUsername();
      let split = name?.split(" ") ?? [];
      const acronym = split
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
      setAchronym(acronym);
    } catch (error) {
      throw new error(error);
    }
  };
  const showResultCont = () => {
    setIsSearching(true);
  };

  const hideResultCont = () => {
    setIsSearching(false);
  };

  const resizeSidebar = () => {
    setSizeSidebar((prevSize) =>
      prevSize == "fullwidth" ? "minwidth" : "fullwidth"
    );
  };

  const showAllModulesMenu = () => {
    setviewAllModules(true);
  };
  const hideAllModulesMenu = () => {
    setviewAllModules(false);
  };

  const registerNavigation = useRef(false);
  useEffect(() => {
    if (!activeTab) return;

    const { basePath } = environment;
    window.history.pushState(null, "", basePath + activeTab.path);
    if (activeTab.id == -1) return;
    const itemToAdd = {
      moduleId: activeTab.isModule ? activeTab.id : null,
      resourceId: activeTab.isModule ? null : activeTab.id,
    };
    if (!registerNavigation.current) {
      registerNavigation.current = true;
      updateHistoryNavigation(itemToAdd)
        .then((response) => {
          registerNavigation.current = false;
        })
        .catch((error) => {});
    }
  }, [activeTab]);

  const handlerCloseTab = (e, tab) => {
    e.stopPropagation();
    dispatch(closeTab(tab.path));
  };
  const pickTab = (tab) => {
    dispatch(setActiveTab(tab.path));
  };
  const handlerRedirectionModule = (module) => {
    setviewAllModules(false);
    const moduleToAdd = {
      id: module.id,
      title: module.name,
      color: module.color,
      icon: iconsMapSvg[module.icon],
      path: module.url,
      isPinned: false,
      componentKey: module.name,
      date: generateUUID(),
      isModule: true,
    };

    dispatch(addTab(moduleToAdd));
  };
  const homeInfo = {
    moduleIcon: "icon-home_icon",
    moduleColor: "#919ce6",
    title: "Home",
    menuTitle: "Home",
    moduleId: 11,
    dataBreadCrumbs: [
      <Link
        key={2}
        underline="none"
        sx={{ color: "#000000", cursor: "auto", fontSize: "var(--p-size)" }}
        onClick={() => navigate("/secure/customdashboard")}
      >
        Home
      </Link>,
    ],
  };

  const configurationInfo = {
    moduleIcon: "icon-settings",
    moduleColor: "#7bb9db",
    title: "Configuration",
    menuTitle: "Configuration",
    moduleId: 1,
    dataBreadCrumbs: "/configuration",
  };

  const storeInfo = {
    moduleIcon: "icon-stores",
    moduleColor: "#eb9090",
    title: "Stores",
    menuTitle: "Stores",
    moduleId: 3,
    dataBreadCrumbs: "/store",
  };

  const supplyChainInfo = {
    moduleIcon: "icon-supply-chain",
    moduleColor: "#F38A00",
    title: "Supply Chain",
    menuTitle: "Supply Chain",
    moduleId: 12,
    dataBreadCrumbs: "/supplychain",
  };

  const vendorInfo = {
        moduleIcon: "icon-business",
    moduleColor: "#E19357",
    title: "Vendor",
    menuTitle: "Vendor",
    moduleId: 13,
    dataBreadCrumbs: "/vendor",
  }

  const getComponent = (key) => {
    switch (key) {
      case "Supply Chain":
        return <SupplyChainDashboardModule workStream={"supplychain"} navBarInfo={supplyChainInfo} />;
      case "Stores":
        return <StoreDashboardModule workStream={"stores"} navBarInfo={storeInfo} />;
      case "CustomDashboard":
        return <HomeDashboardModule workStream={"home"} navBarInfo={homeInfo} />;
      case "Configuration":
        return (
          <ConfigurationDashboardModule
            workStream={"configuration"}
            navBarInfo={configurationInfo}
          />
        );
      case "AircraftConfiguration":
        return <AircraftConfiguration />;
      case "PartsConfiguration":
        return <PartsConfiguration />;
      case "PackageIntake":
        return <PackageIntake />;
      case "LocationsConfiguration":
        return <LocationsConfigurationComponent />;
      case "InventoryManagement":
        return <InventoryManagement />;
      case "PartRequest":
        return <PartRequest />;
      case "PartRequestSupplyChain":
        return <PartRequestManagement />;
      case "NewPartRequest":
        return <NewPartRequest />;
      case "InventoryTransaction":
        return <InventoryTransaction />;
      case "OrdersManagement":
        return <OrdersManagement />;
      case "QuoteTrack":
        return <QuoteTrack />;
      case "ReceivingManagement":
        return <ReceivingManagement />;
      case "Vendor":
        return <VendorDashboardModule workStream={"vendor"} navBarInfo={vendorInfo} />;
      case "VendorApproval":
        return <VendorApproval />;
      case "VendorAwb":
        return <VendorAwb />;
      case "Discrepancy":
        return <Discrepancy />;
      // case "quoteEntry":
      // return <QuoteEntry />;
      default:
        return <PathNotFoundComponent />;
    }
  };
  const location = useLocation();
  const getMenuModules = async () => {
    try {
      const dataModules = await getActiveMenuModules();
      if (
        dataModules?.status === HTTP_RESPONSE_CODES.SUCCESS &&
        Array.isArray(dataModules.data?.load)
      ) {
        const modules = [...dataModules.data.load];
        const defaultCustomDashoard = {
          id: 11,
          title: "Home",
          color: "#919CE6",
          icon: "icon-home_icon",
          path: "/customdashboard",
          description: "Home",
          isPinned: false,
          componentKey: "CustomDashboard",
          date: generateUUID(),
          isModule: true,
        };

        //AddTabModules
        setmodules_availables(modules);
        if (location.pathname == "/secure/customdashboard") {
          dispatch(addTab(defaultCustomDashoard));
        } else {
          dispatch(addTabWithoutActive(defaultCustomDashoard));
        }
      }
    } catch (error) {
      console.error("Error al obtener los módulos del menú:", error);
    }
  };

  useEffect(() => {
    getMenuModules();
    let companyId = parseInt(localStorage.getItem("u_company_id"));
    getAnchoredResource(companyId);
    createAchronym();

    setCompanies(() => {
      const companies = JSON.parse(localStorage.getItem("u_companies")) || [];
      const company_Id = parseInt(localStorage.getItem("u_company_id"));
      const selectedCompany = companies.find(
        (company) => company.id === company_Id
      );

      setCompanySelected(selectedCompany || null);

      return companies;
    });

    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const changeCompanySelected = (data) => {
    try {
      setAnchorEl(null);
      localStorage.setItem("u_company_id", data.id);
      localStorage.setItem("u_company_name", data.name);
      window.location.reload();
    } catch (e) {
      console.error(e);
    }
  };
  function generateUUID() {
    return crypto.randomUUID();
  }
  const getAnchoredResource = async (companyId) => {
    const request = await getAnchoredResourceByUser(companyId);
    if (request.data.load != null) {
      let resources = request.data.load || [];
      resources.forEach((element) => {
        let itemToAdd =
          element.resourceId != null ? element.resourceId : element.moduleId;
        const match = tabMap[itemToAdd.url];
        const icon =
          element.resourceId != null
            ? element.resourceId.icon
            : iconsMapSvg[element.moduleId.icon];
        if (match) {
          dispatch(
            addTabPinned({
              icon: icon,
              color: itemToAdd.color,
              path: itemToAdd.url,
              title: itemToAdd.name,
              id: itemToAdd.id,
              isPinned: true,
              componentKey: match.componentKey,
              isModule: element.moduleId != null,
              date: generateUUID(),
            })
          );
        }
      });
    }
  };

  return (
    <>
      <section className="wrapper-container">
        <section
          className={`sidebar bg-black-mid ${
            sizeSidebar == "fullwidth" ? "fullwidth" : "minwidth"
          }`}
          id="sideBar"
        >
          {/* all modules menu */}

          <section
            className={`all-modules-menu bg-white ${
              viewAllModules ? "visualize-all-modules" : ""
            }`}
            onMouseEnter={showAllModulesMenu}
            onMouseLeave={hideAllModulesMenu}
          >
            {modules_availables.map((module) => {
              return (
                <span className={"module-span-icon"} key={module.id}>
                  <img
                    style={{
                      backgroundColor: module.color,
                    }}
                    src={iconsMap[module.icon]}
                    alt={module.name}
                    className={module.name}
                    onClick={() => {
                      handlerRedirectionModule(module);
                    }}
                  />{" "}
                  <p className="txt-black-mid">{module.name}</p>
                </span>
              );
            })}

            {modules_availables.length == 0 && (
              <>
                <Tooltip title="Home">
                  <span className={"module-span-icon"}>
                    <img
                      style={{
                        backgroundColor: "#C396EE",
                      }}
                      src={homeIcon}
                      alt={"Home"}
                      className={"Custom dashboard"}
                      onClick={() => {
                        let homeDummyData = {
                          id: 11,
                          title: "Home",
                          color: "#919CE6",
                          icon: "icon-home_icon",
                          path: "/customdashboard",
                          description: "Home",
                          isPinned: false,
                          componentKey: "CustomDashboard",
                          date: generateUUID(),
                          isModule: true,
                        };
                        dispatch(addTab(homeDummyData));
                      }}
                    />
                    {/*change redirection*/}
                    <p className="txt-black-mid">{"Home"}</p>
                  </span>
                </Tooltip>
                <div className="limited-access-cont">
                  <img src={limitedAccessImg} alt="Limited Access" />
                  <section>
                    <h2>Limited Access</h2>
                    <p>
                      You have limited access. Request access to additional
                      functionalities.
                    </p>

                    <button>Request Access</button>
                  </section>
                </div>
              </>
            )}
          </section>

          <div className="all-options-cont ">
            <span
              onMouseEnter={showAllModulesMenu}
              onMouseLeave={hideAllModulesMenu}
              className={`span-icon-allModules ${
                viewAllModules ? "bg-white" : ""
              }`}
            >
              <i className="icon-apps"></i>
            </span>

            <section className="open-modules">
              {openTabs.map((tab) => {
                return (
                  <Tooltip key={tab.path} title={tab.title}>
                    <div
                      key={tab.path}
                      className={`resource-tab ${
                        activeTab?.path === tab.path
                          ? "module-active"
                          : "module-inactive"
                      }`}
                      onContextMenu={(event) => {
                        event.preventDefault();
                        const dynamicOptions = getContextMenuOptions(tab);
                        if (contextMenuInfo)
                          attachContextmenuInfo({
                            event,
                            ...contextMenuInfo,
                            options: dynamicOptions,
                            data: tab,
                          });
                      }}
                      onClick={() => pickTab(tab)}
                    >
                      <span
                        className="span-open-module"
                        style={{ backgroundColor: tab.color }}
                      >
                        <i className={tab.icon}></i>
                      </span>
                      {tab.isPinned && <i className="icon-pinned"></i>}
                      {!(tab.isPinned || tab.title === "Home") && (
                        <button
                          className="btn-close-tab"
                          onClick={(e) => handlerCloseTab(e, tab)}
                        >
                          <i className="icon-cross"></i>
                        </button>
                      )}
                    </div>
                  </Tooltip>
                );
              })}
            </section>
          </div>

          <span className="resize-sidebar-icon-cont " onClick={resizeSidebar}>
            <i
              className="icon-arrow-down"
              style={{
                color: "var(--white)",
              }}
            ></i>
          </span>
        </section>

        {/* navbar and main content section */}
        <section
          className={`navbar-mainCont-container  ${
            sizeSidebar == "fullwidth" ? "minwidth" : "fullwidth"
          }`}
        >
          {/* <NavBar breadcrumbs="configuration/parts" /> */}
          <main className="main-content-wrapper">
            {openTabs.map((tab) => {
              if (activeTab?.path !== tab.path) return null;

              const match = tabMap[tab.path]; // puede ser undefined si no está en el mapa
              const shouldKeepAlive = !!match?.keepAlive;
              const content = getComponent(tab.componentKey);

              return shouldKeepAlive ? (
                <KeepAlive key={tab.path} id={`${tab.date}-${tab.id}`}>
                  {content}
                </KeepAlive>
              ) : (
                // SIN KeepAlive => se desmonta al cambiar de pestaña
                <React.Fragment key={tab.path}>{content}</React.Fragment>
              );
            })}
            {!activeTab && children}
          </main>
        </section>

        {/* bottom details bar */}
        <section className="wrapper-details-bar">
          <span
            className={`wrapper-details-bar-version-data ${
              sizeSidebar == "fullwidth" ? "fullwidth" : "minwidth"
            }`}
          >
            <b>Kodo</b>
            <span>V1.0</span>
          </span>

          <section>
            <p>
              {time.getUTCHours().toString().padStart(2, "0")}:
              {time.getUTCMinutes().toString().padStart(2, "0")}:
              {time.getUTCSeconds().toString().padStart(2, "0")} GMT
            </p>
            <p>&copy; {new Date().getFullYear()} MBA Firm</p>
            <section>
              <p>Test</p>
              <span>T</span>
            </section>
          </section>
        </section>
      </section>
    </>
  );
};
